import { Component, OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ProductTypePipe } from "../../product-type.pipe";

import * as echarts from "echarts";
import * as _ from "lodash";
import * as moment from "moment";


import { Domain as WebsideDomain } from "../../../../../lib/Domain/Webside";
import { Domain as ProductDomain } from "../../../../../lib/Domain/Product";
import { Domain } from "../../../../../lib/Domain";

import { HttpService } from "../../http.service";

@Component({
  selector: "app-smart-panel-detail",
  templateUrl: "./smart-panel-detail.component.html",
  styleUrls: ["./smart-panel-detail.component.css"]
})
export class SmartPanelDetailComponent implements OnInit {

  constructor(private httpService: HttpService) { }
  @Input() Item: WebsideDomain.IProduct = undefined;
  @Input() Time: Date = new Date();
  private now = moment().format("YYYY-MM-DD");
  private hour_x = ["12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am",
    "12pm", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"]

  // public gridpower_chart: echarts.EChartOption;
  // public loadpower_chart: echarts.EChartOption;
  // public battery_chart: echarts.EChartOption;
  // public generator_chart: echarts.EChartOption;

  // private IPanelInfo: WebsideDomain.ISmartPanelStatusResult;

  private IPanelInfo: WebsideDomain.ISmartPanelStatusResult = undefined;

  public realtime = {
    totaldemand: 0,
    totalCount: 0,
    cbitems: [],
  };
  @Input() fn = {
    left: false,
    middle: false,
    right: false
  };
  ngOnInit() {
    this.SetTimer();
  }

  private SetTimer() {
    setInterval(async () => {
      if (this.Item) {

        await this.process();

        // if (moment(this.Time).format("YYYY-MM-DD") === this.now) {
        //     this.process(await this.httpService.energystorageService.data(this.Item.uuid, this.Time));
        // }
      }
    }, 60 * 1000);
  }

  async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    await this.process();
    // console.log(changes);
    // console.log(this.fn);
  }

  private async process() {
    this.IPanelInfo = await this.httpService.smartPanelService.Status(this.Item.uuid);
    // 暫時排除無更新的資料
    this.IPanelInfo.cbs = _.filter(this.IPanelInfo.cbs, (v: WebsideDomain.ISmartPanelStatusCBResult) => {
      return v.v !== undefined;
    });
    if (this.fn.left) {
      // 暫時排除無更新的資料
      this.IPanelInfo.cbs = _.filter(this.IPanelInfo.cbs, (v: WebsideDomain.ISmartPanelStatusCBResult) => {
        return v.c.enable === true;
      });
    }
    if (this.fn.middle) {
      // 依照更新時間排序
      this.IPanelInfo.cbs = _.orderBy(this.IPanelInfo.cbs, (v: WebsideDomain.ISmartPanelStatusCBResult) => {
        return v.v.update_time_stamp;
      }).reverse();
    } else {
      // 總迴路第一v.c.meta_data.main_id
      this.IPanelInfo.cbs = _.orderBy(this.IPanelInfo.cbs, ["c.meta_data.main_id", "c.meta_data.name"]).reverse();
    }
    this.realtime.totalCount = this.IPanelInfo.cbs.length;
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/component/smart-panel-detail/smart-panel-detail.component.ts